import PropTypes from 'prop-types'
import PopupNew from '../../components/popup-new'
import { Iframe } from './styledComponents'
import config from '../../../proxyConfig'
import { useLanguageStore } from '../../zustand/language/use-language-store'
import { useBrowserStore } from '../../zustand/browser-store/use-browser-store'
import { getTierName } from '../../react-query/authentication/queries/use-me-query'

const UpgradePlanPopup = ({ close }) => {
  const tierName = getTierName()
  const { locale } = useLanguageStore()
  const { windowHeight } = useBrowserStore()
  const license = tierName?.toLowerCase() ?? ''

  return (
    <PopupNew
      closePopup={close}
      title="&nbsp;"
      size="LARGE"
      rounded={true}
      trueCenter={true}
      windowHeight={windowHeight}
      showCloseTopRight
    >
      <Iframe src={`${config.pricingTable}?lang=${locale}&tool=${license}`} />
    </PopupNew>
  )
}

UpgradePlanPopup.propTypes = {
  close: PropTypes.func.isRequired
}

export default UpgradePlanPopup
